"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_URLS = void 0;
exports.API_URLS = {
    listings: {
        qa: {
            serverSide: 'https://listings-api.svc.qa.noths.com/api/v1/listings',
            clientSide: 'https://api.public.shared.qa.noths.com/api/listings/v1',
        },
        prod: {
            serverSide: 'https://listings-api.svc.prod.noths.com/api/v1/listings',
            clientSide: 'https://api.notonthehighstreet.com/api/listings/v1',
        },
    },
    recommendations: {
        qa: {
            serverSide: 'https://listings-api.svc.qa.noths.com/api/v1/recommendations',
            clientSide: 'https://api.public.shared.qa.noths.com/api/recommendations/v1',
        },
        prod: {
            serverSide: 'https://listings-api.svc.prod.noths.com/api/v1/recommendations',
            clientSide: 'https://api.notonthehighstreet.com/api/recommendations/v1',
        },
    },
};
